import apiFetch from '@wordpress/api-fetch'
import FrontPageEnum from '../enumerators/FrontPageEnum'

export default class SocialWallComponent {
    constructor() {
        this.socialWall()
    }

    socialWall() {
        if (
            $(FrontPageEnum.STRATE_SOCIAL_WALL).length > 0 &&
            !$(FrontPageEnum.STRATE_SOCIAL_WALL).is(':hidden')
        ) {
            apiFetch({
                path: Customer.irisSsoInstagramPath,
                method: 'POST',
                data: { limit: 10 },
            })
                .then((result) => {
                    $(FrontPageEnum.STRATE_SOCIAL_WALL).html(result.render)
                    import(
                        '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                    ).then(({ HcLazyload }) => {
                        HcLazyload.update()
                    })
                })
                .catch(() => {
                    $(FrontPageEnum.STRATE_SOCIAL_WALL).html(Customer.irisSsoInstagramError)
                })
        }
    }
}
